export default __webpack_public_path__ + "static/media/review-5.563475a3.png";